import { InitialStateType, SetIsPosPaymentAction } from '../types';

export const setIsPosPayment = (state: InitialStateType, action: SetIsPosPaymentAction): InitialStateType => ({
  ...state,
  isPosPayment: action.payload,
});
